export const sentences = [
  // Part 1: Greetings (1-50)
  { id: 1, en: "Good morning!", zh: "早安！", category: "greeting" },
  { id: 2, en: "Good afternoon!", zh: "午安！", category: "greeting" },
  { id: 3, en: "Good evening!", zh: "晚安！", category: "greeting" },
  { id: 4, en: "How are you?", zh: "你好嗎？", category: "greeting" },
  { id: 5, en: "I'm fine, thank you.", zh: "我很好，謝謝。", category: "greeting" },
  { id: 6, en: "Nice to meet you.", zh: "很高興認識你。", category: "greeting" },
  { id: 7, en: "What's your name?", zh: "你叫什麼名字？", category: "greeting" },
  { id: 8, en: "My name is...", zh: "我叫...", category: "greeting" },
  { id: 9, en: "Where are you from?", zh: "你來自哪裡？", category: "greeting" },
  { id: 10, en: "I'm from Taiwan.", zh: "我來自台灣。", category: "greeting" },
  { id: 11, en: "What do you do?", zh: "你做什麼工作？", category: "greeting" },
  { id: 12, en: "I'm an electrical engineer.", zh: "我是電子工程師。", category: "work" },
  { id: 13, en: "I work in the semiconductor industry.", zh: "我在半導體產業工作。", category: "work" },
  { id: 14, en: "How's everything going?", zh: "一切都好嗎？", category: "greeting" },
  { id: 15, en: "Pretty good, thanks!", zh: "很不錯，謝謝！", category: "greeting" },
  { id: 16, en: "Long time no see!", zh: "好久不見！", category: "greeting" },
  { id: 17, en: "It's great to see you again.", zh: "很高興再見到你。", category: "greeting" },
  { id: 18, en: "Have a nice day!", zh: "祝你有美好的一天！", category: "greeting" },
  { id: 19, en: "See you later!", zh: "待會見！", category: "greeting" },
  { id: 20, en: "Take care!", zh: "保重！", category: "greeting" },
  { id: 21, en: "Good night!", zh: "晚安！", category: "greeting" },
  { id: 22, en: "Sleep well!", zh: "睡个好觉！", category: "greeting" },
  { id: 23, en: "Have a good weekend!", zh: "周末愉快！", category: "greeting" },
  { id: 24, en: "How was your day?", zh: "今天过得怎样？", category: "greeting" },
  { id: 25, en: "It was busy but good.", zh: "很忙但还不错。", category: "greeting" },
  { id: 26, en: "What are you up to?", zh: "你在忙什麼？", category: "greeting" },
  { id: 27, en: "Not much, just working.", zh: "沒什麼，就在工作。", category: "greeting" },
  { id: 28, en: "Would you like some coffee?", zh: "要喝咖啡嗎？", category: "daily" },
  { id: 29, en: "Yes, please.", zh: "好的，謝謝。", category: "daily" },
  { id: 30, en: "No, thank you.", zh: "不用了，謝謝。", category: "daily" },
  { id: 31, en: "Do you have any plans today?", zh: "今天有什麼計畫嗎？", category: "daily" },
  { id: 32, en: "Let's meet up sometime.", zh: "找時間碰面吧。", category: "daily" },
  { id: 33, en: "That sounds great!", zh: "聽起來很棒！", category: "daily" },
  { id: 34, en: "I'm looking forward to it.", zh: "我很期待。", category: "daily" },
  { id: 35, en: "What time is it?", zh: "現在幾點？", category: "daily" },
  { id: 36, en: "It's about 3 o'clock.", zh: "大約三點。", category: "daily" },
  { id: 37, en: "Sorry, I'm late!", zh: "抱歉，我遲到了！", category: "daily" },
  { id: 38, en: "No problem.", zh: "沒關係。", category: "daily" },
  { id: 39, en: "Thank you so much!", zh: "非常感謝！", category: "daily" },
  { id: 40, en: "You're welcome!", zh: "不客氣！", category: "daily" },
  { id: 41, en: "Excuse me.", zh: "不好意思。", category: "daily" },
  { id: 42, en: "I'm sorry.", zh: "對不起。", category: "daily" },
  { id: 43, en: "I apologize.", zh: "我道歉。", category: "daily" },
  { id: 44, en: "That's okay.", zh: "沒關係。", category: "daily" },
  { id: 45, en: "No worries.", zh: "別擔心。", category: "daily" },
  { id: 46, en: "Can you repeat that?", zh: "可以再說一次嗎？", category: "daily" },
  { id: 47, en: "Could you speak more slowly?", zh: "可以說慢一點嗎？", category: "daily" },
  { id: 48, en: "I don't understand.", zh: "我不懂。", category: "daily" },
  { id: 49, en: "I understand now.", zh: "我現在懂了。", category: "daily" },
  { id: 50, en: "Got it!", zh: "知道了！", category: "daily" },
  
  // Part 2: Work (51-100)
  { id: 51, en: "Let's get started.", zh: "我們開始吧。", category: "work" },
  { id: 52, en: "I'll share my screen.", zh: "我分享我的螢幕。", category: "work" },
  { id: 53, en: "Can you see my screen?", zh: "你能看到我的螢幕嗎？", category: "work" },
  { id: 54, en: "Yes, I can see it.", zh: "是的，我能看到。", category: "work" },
  { id: 55, en: "The agenda for today is...", zh: "今天的議程是...", category: "work" },
  { id: 56, en: "First, let me explain...", zh: "首先，讓我說明...", category: "work" },
  { id: 57, en: "Let me walk you through this.", zh: "讓我帶你過一遍。", category: "work" },
  { id: 58, en: "Do you have any questions?", zh: "有任何問題嗎？", category: "work" },
  { id: 59, en: "I'll send you the details later.", zh: "稍後把詳情傳給你。", category: "work" },
  { id: 60, en: "Please check your email.", zh: "請檢查你的郵件。", category: "work" },
  { id: 61, en: "Let's schedule a meeting.", zh: "我們安排個會議吧。", category: "work" },
  { id: 62, en: "What time works for you?", zh: "你什麼時間方便？", category: "work" },
  { id: 63, en: "I'm available tomorrow.", zh: "我明天有空。", category: "work" },
  { id: 64, en: "Does that work for you?", zh: "你可以嗎？", category: "work" },
  { id: 65, en: "I'll confirm and get back to you.", zh: "我確認後回覆你。", category: "work" },
  { id: 66, en: "The project is on track.", zh: "專案進度正常。", category: "work" },
  { id: 67, en: "We're slightly behind schedule.", zh: "我們稍微落後進度。", category: "work" },
  { id: 68, en: "We need to catch up.", zh: "我們需要趕上進度。", category: "work" },
  { id: 69, en: "Let me update you on the progress.", zh: "讓我更新進度給你。", category: "work" },
  { id: 70, en: "The deadline is next Friday.", zh: "截止日期是下週五。", category: "work" },
  { id: 71, en: "We might need more time.", zh: "我們可能需要更多時間。", category: "work" },
  { id: 72, en: "Can we extend the deadline?", zh: "可以延後截止日期嗎？", category: "work" },
  { id: 73, en: "I'll look into it.", zh: "我會調查一下。", category: "work" },
  { id: 74, en: "Let me check with my team.", zh: "讓我問一下團隊。", category: "work" },
  { id: 75, en: "That's a good point.", zh: "這是個好問題。", category: "work" },
  { id: 76, en: "I agree with you.", zh: "我同意你的看法。", category: "work" },
  { id: 77, en: "I see your point, but...", zh: "我明白你的意思，但...", category: "work" },
  { id: 78, en: "Let's discuss this offline.", zh: "我們私下討論這個。", category: "work" },
  { id: 79, en: "I'll set up a call.", zh: "我來安排一通電話。", category: "work" },
  { id: 80, en: "The meeting is at 10 AM.", zh: "會議在上午10點。", category: "work" },
  { id: 81, en: "Please join the Zoom call.", zh: "請加入 Zoom 會議。", category: "work" },
  { id: 82, en: "The link is in the calendar invite.", zh: "連結在行事曆邀請裡。", category: "work" },
  { id: 83, en: "Audio is not working.", zh: "音訊有問題。", category: "work" },
  { id: 84, en: "Let me try again.", zh: "讓我再試一次。", category: "work" },
  { id: 85, en: "You can hear me now, right?", zh: "你現在聽得到我說話嗎？", category: "work" },
  { id: 86, en: "Please mute yourself.", zh: "請關閉你的麥克風。", category: "work" },
  { id: 87, en: "Sorry, I was on mute.", zh: "抱歉，我麥克風開著。", category: "work" },
  { id: 88, en: "Let me share the document.", zh: "讓我分享這個文件。", category: "work" },
  { id: 89, en: "Can you download the file?", zh: "你能下載這個檔案嗎？", category: "work" },
  { id: 90, en: "The file is too large.", zh: "檔案太大了。", category: "work" },
  { id: 91, en: "I'll compress it and resend.", zh: "我壓縮後再傳。", category: "work" },
  { id: 92, en: "What's the status?", zh: "進度怎麼樣？", category: "work" },
  { id: 93, en: "It's almost done.", zh: "快完成了。", category: "work" },
  { id: 94, en: "We need your approval.", zh: "我們需要你的批准。", category: "work" },
  { id: 95, en: "Please review and confirm.", zh: "請審核並確認。", category: "work" },
  { id: 96, en: "Looks good to me.", zh: "我覺得沒問題。", category: "work" },
  { id: 97, en: "Approved!", zh: "核准！", category: "work" },
  { id: 98, en: "Rejected. Please revise.", zh: "駁回，請修改。", category: "work" },
  { id: 99, en: "Let's circle back to this.", zh: "我們回過頭討論這個。", category: "work" },
  { id: 100, en: "I'll follow up next week.", zh: "我下週跟進。", category: "work" },

  // Part 3: Technical (101-150)
  { id: 101, en: "From a technical standpoint...", zh: "從技術上來說...", category: "tech" },
  { id: 102, en: "In my experience...", zh: "根據我的經驗...", category: "tech" },
  { id: 103, en: "Let me explain the technical details.", zh: "讓我解釋技術細節。", category: "tech" },
  { id: 104, en: "The system architecture is...", zh: "系統架構是...", category: "tech" },
  { id: 105, en: "We're using a new design.", zh: "我們使用新設計。", category: "tech" },
  { id: 106, en: "The chip is fabricated in...", zh: "晶片是在...製造的", category: "tech" },
  { id: 107, en: "The specification requires...", zh: "規格要求...", category: "tech" },
  { id: 108, en: "We need to optimize the performance.", zh: "我們需要優化效能。", category: "tech" },
  { id: 109, en: "The power consumption is too high.", zh: "功耗太高了。", category: "tech" },
  { id: 110, en: "We need to reduce the latency.", zh: "我們需要降低延遲。", category: "tech" },
  { id: 111, en: "The test results show...", zh: "測試結果顯示...", category: "tech" },
  { id: 112, en: "There's a bug in the system.", zh: "系統有 bug。", category: "tech" },
  { id: 113, en: "We're still debugging.", zh: "我們還在除錯中。", category: "tech" },
  { id: 114, en: "The issue has been fixed.", zh: "問題已修復。", category: "tech" },
  { id: 115, en: "Please verify the output.", zh: "請驗證輸出。", category: "tech" },
  { id: 116, en: "Does it meet the requirements?", zh: "這符合需求嗎？", category: "tech" },
  { id: 117, en: "We need more testing.", zh: "我們需要更多測試。", category: "tech" },
  { id: 118, en: "The prototype is ready.", zh: "原型機好了。", category: "tech" },
  { id: 119, en: "We're waiting for the samples.", zh: "我們在等樣品。", category: "tech" },
  { id: 120, en: "The delivery is delayed.", zh: "交貨延遲了。", category: "tech" },
  { id: 121, en: "When can we expect delivery?", zh: "什麼時候可以交貨？", category: "tech" },
  { id: 122, en: "The supply chain is affected.", zh: "供應鏈受到影響。", category: "tech" },
  { id: 123, en: "We're facing some challenges.", zh: "我們面臨一些挑戰。", category: "tech" },
  { id: 124, en: "We need to find a workaround.", zh: "我們需要找解決方案。", category: "tech" },
  { id: 125, en: "Can you provide more details?", zh: "可以提供更多細節嗎？", category: "tech" },
  { id: 126, en: "The datasheet is attached.", zh: " datasheet 在附件裡。", category: "tech" },
  { id: 127, en: "Please refer to the manual.", zh: "請參考手冊。", category: "tech" },
  { id: 128, en: "I found the problem.", zh: "我找到問題了。", category: "tech" },
  { id: 129, en: "It's a hardware issue.", zh: "是硬體問題。", category: "tech" },
  { id: 130, en: "It's a software bug.", zh: "是軟體 bug。", category: "tech" },
  { id: 131, en: "We need to update the firmware.", zh: "我們需要更新韌體。", category: "tech" },
  { id: 132, en: "The calibration is done.", zh: "校準完成了。", category: "tech" },
  { id: 133, en: "The signal looks clean.", zh: "訊號看起來很乾淨。", category: "tech" },
  { id: 134, en: "There's interference.", zh: "有干擾。", category: "tech" },
  { id: 135, en: "We need to shield it.", zh: "我們需要屏蔽它。", category: "tech" },
  { id: 136, en: "The PCB layout is done.", zh: "PCB 佈局完成了。", category: "tech" },
  { id: 137, en: "We need to reroute.", zh: "我們需要重新走線。", category: "tech" },
  { id: 138, en: "The impedance matching is critical.", zh: "阻抗匹配很關鍵。", category: "tech" },
  { id: 139, en: "We're using differential pairs.", zh: "我們使用差分對。", category: "tech" },
  { id: 140, en: "The clock signal is 100 MHz.", zh: "時脈訊號是 100 MHz。", category: "tech" },
  { id: 141, en: "We need to synchronize.", zh: "我們需要同步。", category: "tech" },
  { id: 142, en: "The timing diagram shows...", zh: "時序圖顯示...", category: "tech" },
  { id: 143, en: "The setup time is 2 nanoseconds.", zh: "建立時間是 2 奈秒。", category: "tech" },
  { id: 144, en: "We're using SPI interface.", zh: "我們使用 SPI 介面。", category: "tech" },
  { id: 145, en: "It's compatible with...", zh: "它相容於...", category: "tech" },
  { id: 146, en: "We need to downgrade the version.", zh: "我們需要降級版本。", category: "tech" },
  { id: 147, en: "The new feature is working.", zh: "新功能運作正常。", category: "tech" },
  { id: 148, en: "The integration is complete.", zh: "整合完成了。", category: "tech" },
  { id: 149, en: "We need to validate.", zh: "我們需要驗證。", category: "tech" },
  { id: 150, en: "It's ready for mass production.", zh: "準備好量產了。", category: "tech" },

  // Part 4: Business & Social (151-200)
  { id: 151, en: "Nice to work with you.", zh: "很高興與你合作。", category: "business" },
  { id: 152, en: "Thank you for your time.", zh: "謝謝你的時間。", category: "business" },
  { id: 153, en: "I appreciate your help.", zh: "感謝你的幫忙。", category: "business" },
  { id: 154, en: "You've been very helpful.", zh: "你幫了大忙。", category: "business" },
  { id: 155, en: "Let's celebrate!", zh: "我們慶祝一下吧！", category: "business" },
  { id: 156, en: "The deal is done!", zh: "成交了！", category: "business" },
  { id: 157, en: "We're happy with the result.", zh: "我們對結果很滿意。", category: "business" },
  { id: 158, en: "Looking forward to our next project.", zh: "期待我們的下個專案。", category: "business" },
  { id: 159, en: "It's been a pleasure.", zh: "很榮幸。", category: "business" },
  { id: 160, en: "Have a safe trip!", zh: "一路平安！", category: "business" },
  { id: 161, en: "Bon voyage!", zh: "一路順風！", category: "business" },
  { id: 162, en: "Enjoy your vacation!", zh: "享受你的假期！", category: "business" },
  { id: 163, en: "Merry Christmas!", zh: "聖誕快樂！", category: "business" },
  { id: 164, en: "Happy New Year!", zh: "新年快樂！", category: "business" },
  { id: 165, en: "Happy birthday!", zh: "生日快樂！", category: "business" },
  { id: 166, en: "Congratulations!", zh: "恭喜！", category: "business" },
  { id: 167, en: "Well done!", zh: "做得好！", category: "business" },
  { id: 168, en: "Excellent work!", zh: "出色的工作！", category: "business" },
  { id: 169, en: "I'm impressed!", zh: "令人印象深刻！", category: "business" },
  { id: 170, en: "That's amazing!", zh: "太厲害了！", category: "business" },
  { id: 171, en: "Sounds good!", zh: "聽起來不錯！", category: "business" },
  { id: 172, en: "I'm in!", zh: "我加入！", category: "business" },
  { id: 173, en: "Let's do it!", zh: "做吧！", category: "business" },
  { id: 174, en: "I'll think about it.", zh: "我想一想。", category: "business" },
  { id: 175, en: "Need some time to decide.", zh: "需要時間決定。", category: "business" },
  { id: 176, en: "Can we negotiate?", zh: "可以談判嗎？", category: "business" },
  { id: 177, en: "What's your budget?", zh: "你的預算是多少？", category: "business" },
  { id: 178, en: "We have a limited budget.", zh: "我們預算有限。", category: "business" },
  { id: 179, en: "It's within our budget.", zh: "在我們預算內。", category: "business" },
  { id: 180, en: "Let's find a win-win solution.", zh: "我們找雙贏方案。", category: "business" },
  { id: 181, en: "I understand your concern.", zh: "我理解你的疑慮。", category: "business" },
  { id: 182, en: "We'll do our best.", zh: "我們會盡力。", category: "business" },
  { id: 183, en: "Please keep us updated.", zh: "請隨時更新我們。", category: "business" },
  { id: 184, en: "Feel free to reach out.", zh: "隨時聯繫我。", category: "business" },
  { id: 185, en: "My door is always open.", zh: "我的門永遠為你開。", category: "business" },
  { id: 186, en: "Let's stay in touch.", zh: "保持聯繫。", category: "business" },
  { id: 187, en: "Here's my business card.", zh: "這是我的名片。", category: "business" },
  { id: 188, en: "What's your email address?", zh: "你的 email 是什麼？", category: "business" },
  { id: 189, en: "I'll add you on LinkedIn.", zh: "我加你 LinkedIn。", category: "business" },
  { id: 190, en: "Nice connecting with you!", zh: "很高興認識你！", category: "business" },
  { id: 191, en: "See you at the conference!", zh: "研討會見！", category: "business" },
  { id: 192, en: "Booth number is...", zh: "攤位號碼是...", category: "business" },
  { id: 193, en: "Let's grab lunch.", zh: "我們去吃午餐。", category: "business" },
  { id: 194, en: "My treat!", zh: "我請客！", category: "business" },
  { id: 195, en: "Let's split the bill.", zh: "我們分帳。", category: "business" },
  { id: 196, en: "Would you like to join us?", zh: "你要加入我們嗎？", category: "business" },
  { id: 197, en: "I'm sorry I can't make it.", zh: "抱歉我無法參加。", category: "business" },
  { id: 198, en: "Next time for sure!", zh: "下次一定！", category: "business" },
  { id: 199, en: "It's been a long day.", zh: "今天真長。", category: "business" },
  { id: 200, en: "Time to call it a day!", zh: "今天到此為止！", category: "business" }
];
